<template>
  <div>
    <el-row>
      <InvoiceAndPaymentTotalCards
        :TabSelected="ActualTabValue"
        :YearSelected="yearSelected"
        :MonthSelected="monthSelected"
        :PaymentTypeSelected="PaymentTypeSelected"
        :PaymentSelected="PaymentSelected"
        :ExecutionSelected="ExecutionSelected"
        :InvoiceType="invoiceType"
        :WeekSelected="weekSelected"
        :ReportUpdated="reportUpdated"
      />
    </el-row>
    <el-row>
      <PaymentAndInvoicingReportFilters
        @onYearSelected="OnYearSelected"
        @onMonthSelected="OnMonthSelected"
        @onPaymentTypeSelected="OnPaymentTypeSelected"
        @ExecutionSelected="OnExecutionSelected"
        @PaymentSelected="OnPaymentSelected"
        @OnInvoiceTypeSelected="OnInvoiceTypeSelected"
        @OnInvoiceWeekSelected="OnInvoiceWeekSelected"
      />
    </el-row>
    <el-row>
      <PaymentAndInvoicingReportTable
        :TabSelected="ActualTabValue"
        :YearSelected="yearSelected"
        :MonthSelected="monthSelected"
        :PaymentTypeSelected="PaymentTypeSelected"
        :PaymentSelected="PaymentSelected"
        :ExecutionSelected="ExecutionSelected"
        :InvoiceType="invoiceType"
        :WeekSelected="weekSelected"
        @InvociesAndPaymentData="onInvoicesAndPaymentsTableCharged"
      />
    </el-row>

    <!-- Event Create Dialog -->
    <!-- <CalendarFinancesEventForm
            ref="form"
            @close-event-dialog="closeEventDialog"
            :form="form"
            :submitMode="submitMode"
            :dialogFormVisible="dialogFormVisible"
            :rulesForDisablingSaveButton="rulesForDisablingSaveButton"
            :rulesForDisablingDelete="rulesForDisablingDelete"
            :eventSelectedIsTask="eventSelectedIsTask"
            :userIsSupervisor="userIsSupervisor"
            :userId="userId"
            :currentlyChosenAgenda="currentlyChosenAgenda"
            :currentChosenCalendarID="currentChosenCalendarID"
            :CurrentResponsableInfo="CurrentResponsableInfo"
          /> -->
  </div>
</template>

<script>
import PaymentAndInvoicingReportTable from "@/components/fiances/reports/table/PaymentAndInvoicingReportTable";
import PaymentAndInvoicingReportFilters from "@/components/fiances/reports/filters/PaymentAndInvoicingReportFilters";
// import CalendarFinancesEventForm from "@/components/calendar/CalendarFinancesEventForm";
import InvoiceAndPaymentTotalCards from "@/components/fiances/reports/Cards/InvoiceAndPaymentTotalCards";

const actualYear = new Date().getFullYear();
const actualMonth = new Date().getMonth() + 1;

export default {
  name: "PaymentAndInvoicingReport",
  components: {
    PaymentAndInvoicingReportTable,
    PaymentAndInvoicingReportFilters,
    // CalendarFinancesEventForm
    InvoiceAndPaymentTotalCards
  },
  props: {
    TabSelected: {
      type: String,
      default: "",
      required: true
    }
  },
  data() {
    return {
      yearSelected: actualYear,
      monthSelected: actualMonth,
      PaymentTypeSelected: 2,
      PaymentSelected: "",
      ExecutionSelected: null,
      invoiceType: "",
      weekSelected: "",
      reportUpdated: false
    };
  },

  mounted() {},
  computed: {
    ActualTabValue() {
      return this.TabSelected;
    }
  },
  methods: {
    OnYearSelected(year) {
      this.yearSelected = year;
    },
    OnMonthSelected(month) {
      this.monthSelected = month;
    },
    OnPaymentTypeSelected(value) {
      this.PaymentTypeSelected = value;
    },
    OnPaymentSelected(value) {
      this.PaymentSelected = value;
    },
    OnExecutionSelected(value) {
      this.ExecutionSelected = value;
    },
    OnInvoiceTypeSelected(type) {
      this.invoiceType = type;
    },
    OnInvoiceWeekSelected(week) {
      this.weekSelected = week;
    },
    onInvoicesAndPaymentsTableCharged() {
      this.reportUpdated = !this.reportUpdated;
    }
  }
};
</script>

<style scoped>
.Bold {
  font-weight: bold;
}
.Blue {
  color: blue;
}
.Red {
  color: darkred;
  background-color: lightsalmon;
  border-color: darkred;
}
.Green {
  color: darkgreen;
  background-color: lightgreen;
  border-color: darkgreen;
}
.Yellow {
  color: darkorange;
  background-color: lightgoldenrodyellow;
  border-color: darkorange;
}
</style>
